export default class MainMenuMobileBehaviourService {
  constructor() {
    this.func = null;
  }

  setCustomBehaviour(func) {
    this.func = func;
  }

  hasCustomBehaviour() {
    return this.func !== null;
  }

  clean() {
    this.func = null;
  }

  invoke() {
    if (typeof this.func === 'function') {
      this.func();
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/components/mainMenuMobile/mainMenuMobileBehaviour.service.js